import React, {useEffect, useState} from 'react'
import {Alert, Box, Button, CircularProgress, Stack, Typography} from '@mui/material'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router-dom'
import {useDispatch} from 'react-redux'
import OnboardingApi from '../../Api/onboarding'
import {actions} from '../../store/vender/Auth/auth.slice'
import HomeApi from '../../Api/home'

type Props = {onFinished: () => void}

export default function OnboardingStepPayment({onFinished}: Props) {
  const {t} = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)
  const [isFinishing, setIsFinishing] = useState(false)
  const [cashEnabled, setCashEnabled] = useState(true)

  useEffect(() => {
    OnboardingApi.getPaymentMethods((res: any) => {
      const list = Array.isArray(res?.data) ? res.data : []
      const cash = list.find(
        (row: any) => String(row.factory_type || row.factory_name || '').toUpperCase() === 'PY_CASH'
      )
      if (cash) {
        setCashEnabled(Number(cash.status) === 1)
      }
    }, setIsLoading)
  }, [])

  const finish = () => {
    OnboardingApi.complete(() => {
      HomeApi.imagesSize((lunch: any) => {
        if (lunch?.data) {
          dispatch(actions.setImagesSize({...lunch.data, is_onboarding_complete: true}))
        } else {
          dispatch(
            actions.setImagesSize({
              is_onboarding_complete: true,
            } as any)
          )
        }
        onFinished()
        navigate('/dashboard')
      }, () => undefined)
    }, setIsFinishing)
  }

  if (isLoading) {
    return (
      <Stack alignItems='center' py={6}>
        <CircularProgress />
      </Stack>
    )
  }

  return (
    <Stack gap={2}>
      <Typography fontWeight={600} fontSize={18}>
        {t('onboarding.step4_title') as string}
      </Typography>

      <Alert icon={<CheckCircleOutlineIcon fontSize='inherit' />} severity='success'>
        {t('onboarding.cod_enabled_message') as string}
      </Alert>

      <Typography fontSize={14} color='text.secondary'>
        {t('onboarding.step4_subtitle') as string}
      </Typography>

      <Box
        p={2}
        border='1px solid #E5E7EB'
        borderRadius='12px'
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        gap={2}
      >
        <Box>
          <Typography fontWeight={600}>{t('cashOnDelivery') as string}</Typography>
          <Typography fontSize={13} color='text.secondary'>
            PY_CASH · {cashEnabled ? (t('payment.enabled') as string) : (t('payment.disabled') as string)}
          </Typography>
        </Box>
      </Box>

      <Typography fontSize={13} color='text.secondary'>
        {t('onboarding.pay_connect_hint') as string}
      </Typography>

      <Box display='flex' justifyContent='space-between' flexWrap='wrap' gap={1}>
        <Button variant='outlined' onClick={() => navigate('/payment-methods')}>
          {t('onboarding.setup_digital_payments') as string}
        </Button>
        <Button variant='contained' disabled={isFinishing} onClick={finish}>
          {isFinishing ? (
            <CircularProgress size={20} color='inherit' />
          ) : (
            (t('onboarding.finish') as string)
          )}
        </Button>
      </Box>
    </Stack>
  )
}
